'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

var _AuthorLink = require('./AuthorLink');

var _AuthorLink2 = _interopRequireDefault(_AuthorLink);

var _Slider = require('./Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChooseFreeProduct = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(ChooseFreeProduct, _React$PureComponent);

    function ChooseFreeProduct() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ChooseFreeProduct);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChooseFreeProduct.__proto__ || (0, _getPrototypeOf2.default)(ChooseFreeProduct)).call.apply(_ref, [this].concat(args))), _this), _this.onChecked = function (e, id) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                discountCampaignId = _this$props.discountCampaignId;

            if (e.target.checked) {
                onChange({ selectedId: id, discountCampaignId: discountCampaignId, unselectedId: _this.getSelectedId() });
            } else {
                onChange({ selectedId: null, discountCampaignId: discountCampaignId, unselectedId: id });
            }
        }, _this.renderProduct = function (product) {
            var discountCampaignId = _this.props.discountCampaignId;
            var id = product.id,
                productName = product.productName,
                authors = product.authors,
                url = product.url,
                thumbnailUrl = product.thumbnailUrl;

            var isSelected = _this.getSelectedId() === id;
            var htmlId = 'gift-' + id;
            var distinctAuthors = _utils2.default.distinctByParam(authors, 'id');

            return _react2.default.createElement(
                'div',
                { key: 'fp_' + id, className: 'gift__item' },
                _react2.default.createElement('input', { name: "gift-" + discountCampaignId, type: 'checkbox', id: htmlId, checked: isSelected, onChange: function onChange(e) {
                        return _this.onChecked(e, id);
                    } }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: htmlId },
                    _react2.default.createElement(
                        'figure',
                        null,
                        _react2.default.createElement('img', { src: thumbnailUrl, alt: '' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'product__title' },
                        productName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'product__authors' },
                        (0, _intersperse2.default)(distinctAuthors.map(function (a) {
                            return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: 'a_' + a.id }, a, { noLink: true }));
                        }), ', ')
                    )
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ChooseFreeProduct, [{
        key: 'getSelectedId',
        value: function getSelectedId() {
            var _props = this.props,
                products = _props.products,
                selectedIds = _props.selectedIds;

            return selectedIds.find(function (id) {
                return products.find(function (p) {
                    return p.id === id;
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var products = this.props.products;

            return _react2.default.createElement(
                _Slider2.default,
                { arrows: products.length > 4 },
                products.map(this.renderProduct)
            );
        }
    }]);
    return ChooseFreeProduct;
}(_react2.default.PureComponent), _class.propTypes = {
    discountCampaignId: _propTypes2.default.number.isRequired,
    products: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    selectedIds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    onChange: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = ChooseFreeProduct;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/ChooseFreeProduct.js
// module id = 1016
// module chunks = 0